import Translate from "@casino/legacy/client/shared/i18n/Translate";
import NextLink from "@casino/legacy/client/shared/NextLink";
import { TypographyText } from "@workspace/frontend-ui";
import { useRouter } from "next/navigation";

const ForgotPasswordLink: FC = () => {
  const router = useRouter();
  return (
    <NextLink
      onTouchEnd={() => router.push("/forgot-password/reset")}
      href="/forgot-password/reset"
    >
      <TypographyText>
        <Translate id="profile.forgot_password" />
      </TypographyText>
    </NextLink>
  );
};

export default ForgotPasswordLink;
